var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTableModifyInsuranceRequestDateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: 16.727,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6,
    width: 18,
    height: 15,
    rx: 2,
    stroke: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 10C3 8.11438 3 7.17157 3.58579 6.58579C4.17157 6 5.11438 6 7 6H17C18.8856 6 19.8284 6 20.4142 6.58579C21 7.17157 21 8.11438 21 10H3Z",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 3L7 6",
    stroke: "#199b8b",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 3L17 6",
    stroke: "#199b8b",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 12,
    width: 4,
    height: 2,
    rx: 0.5,
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 16,
    width: 4,
    height: 2,
    rx: 0.5,
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 12,
    width: 4,
    height: 2,
    rx: 0.5,
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 16,
    width: 4,
    height: 2,
    rx: 0.5,
    fill: "#199b8b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableModifyInsuranceRequestDateIcon);
export default __webpack_public_path__ + "static/media/table-modify-insurance-request-date-icon.8e0f4506c5e8ab533604bdca656ec89c.svg";
export { ForwardRef as ReactComponent };